import React, { useEffect, useRef, useState } from "react";
import taxlotsEmpty from "../../assets/images/svg/taxlotsEmpty.svg";
// import Table from "../Table";
import Tabs from "../Tabs";
import { useParams } from "react-router";
import { Observer, observer } from "mobx-react-lite";
import {
  commaSeperated,
  getDisplayDate,
  lakhAmt,
  numWithUnit,
  showDashIfZero,
  showDataWithRupeeDashOrZero,
} from "../../utils/functions";
// import SortTable from "../../utils/Hooks/SortTable";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import ScrollDataTable from "../Table/ScrollDataTable";
import {
  defaultTaxSortConfig,
  defaultTransactionSortConfig,
} from "../../utils/constants";

const transactionDateCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="transaction_date_cell" style={{ minWidth: "423px" }}>
      {/* {getDisplayDate(data.transaction_date)} */}
      {`${getDisplayDate(data)}`}
    </p>
  );
};

const qtyCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {UserStore.isHybridNormalInstrument
        ? showDashIfZero(Number(rowData[key] || 0)) === "-"
          ? "-"
          : commaSeperated(rowData?.[key])
        : commaSeperated(rowData[key])}
    </p>
  );
};

const priceCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {showDataWithRupeeDashOrZero(
        rowData[key],
        UserStore.isHybridNormalInstrument,
      )}
    </p>
  );
};

const tvaCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {lakhAmt(rowData?.value?.actual_value) || "-"}
    </p>
  );
};

const tvaCellRendererValue = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {numWithUnit(rowData?.value?.value, rowData?.value?.value_type)}
    </p>
  );
};

const tvaCellRenderer1 = (data, rowData, key) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {showDataWithRupeeDashOrZero(
        rowData?.price,
        UserStore.isHybridNormalInstrument,
      )}
    </p>
  );
};

const tvaCellRenderer2 = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {UserStore.isHybridNormalInstrument
        ? rowData[key]?.value
          ? numWithUnit(rowData[key]?.value, rowData[key]?.value_type)
          : "-"
        : numWithUnit(rowData[key]?.value, rowData[key]?.value_type)}
    </p>
  );
};

const infinityirrCellRenderer = (data, rowData, key, index) => {
  return (
    <p
      className={`irr_cell ${
        rowData.type === "Corpus Out" || rowData.type === "SOLD"
          ? "red_text"
          : ""
      }`}
    >
      {rowData?.type?.toUpperCase()}
    </p>
  );
};

const daysHeldCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell">
      {UserStore.isHybridNormalInstrument
        ? showDashIfZero(Number(rowData.days_held || 0))
        : commaSeperated(rowData.days_held)}
    </p>
  );
};

const durationCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="irr_cell" style={{ whiteSpace: "nowrap" }}>
      {rowData[key]?.toUpperCase() || ""}
    </p>
  );
};

const dateCellRenderer = (data, rowData, key) => {
  return <p className="date_cell">{getDisplayDate(rowData.date)}</p>;
};

const accountNameCellRenderer = (data, rowData, key, index) => {
  return (
    <OverflowingText
      text={rowData[key]}
      textClassName="qty_cell"
      position={"left"}
    />
  );
};

const taxLotsColumnUnitBased = [
  {
    label: "Days Held",
    key: "days_held",
    sortable: true,
    cellRenderer: daysHeldCellRenderer,
    keyConfig: {
      clmName: "days_held",
      keysObj: { key1: "days_held" },
      keyLevel: 1,
      type: "numbers",
    },
  },
  {
    label: "Duration",
    key: "type",
    sortable: true,
    keyConfig: {
      clmName: "type",
      keysObj: { key1: "type" },
      keyLevel: 1,
      type: "strings",
    },
    cellRenderer: durationCellRenderer,
  },
  {
    label: "Price",
    key: "price",
    sortable: true,
    keyConfig: {
      clmName: "price",
      keysObj: { key1: "price" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: tvaCellRenderer1,
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    keyConfig: {
      clmName: "quantity",
      keysObj: { key1: "quantity" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: qtyCellRenderer,
  },
  {
    label: "Gain/Loss",
    key: "value",
    sortable: true,
    keyConfig: {
      clmName: "value",
      keysObj: { key1: "value", key2: "actual_value" },
      type: "numbers",
      keyLevel: 2,
    },
    cellRenderer: tvaCellRendererValue,
  },
  {
    label: "Date",
    key: "date",
    sortable: true,
    keyConfig: {
      clmName: "date",
      keysObj: { key1: "date" },
      keyLevel: 1,
      type: "date",
      dateFormat: "ymd",
    },
    cellRenderer: dateCellRenderer,
  },
  {
    label: "Account Name",
    key: "accountName",
    sortable: true,
    keyConfig: {
      clmName: "accountName",
      keysObj: { key1: "accountName" },
      keyLevel: 1,
      type: "strings",
    },
    cellRenderer: accountNameCellRenderer,
  },
];

const taxLotsColumnValueBased = [
  {
    label: "Transaction Date",
    key: "days_held",
    sortable: true,
    width: "30%",
    keyConfig: {
      clmName: "days_held",
      keysObj: { key1: "days_held" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: daysHeldCellRenderer,
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    keyConfig: {
      clmName: "quantity",
      keysObj: { key1: "quantity" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: qtyCellRenderer,
  },
  {
    label: "Price",
    key: "value",
    sortable: true,
    keyConfig: {
      clmName: "value",
      keysObj: { key1: "value", key2: "actual_value" },
      type: "numbers",
      keyLevel: 2,
    },
    cellRenderer: tvaCellRenderer,
  },
  {
    label: "Amount",
    key: "amount",
    sortable: true,
    keyConfig: {
      clmName: "amount",
      keysObj: { key1: "amount" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: dateCellRenderer,
  },
  {
    label: "Transaction Type",
    key: "type",
    sortable: true,
    keyConfig: {
      clmName: "type",
      keysObj: { key1: "type" },
      keyLevel: 1,
      type: "strings",
    },
    cellRenderer: durationCellRenderer,
  },
];

const infinityTransectionColumn = [
  {
    label: "Transaction Date",
    key: "transaction_date",
    sortable: true,
    keyConfig: {
      clmName: "transaction_date",
      keysObj: { key1: "transaction_date" },
      keyLevel: 1,
      type: "date",
      dateFormat: "ymd",
    },
    cellRenderer: transactionDateCellRenderer,
  },
  {
    label: "Transaction Type",
    key: "type",
    sortable: true,
    keyConfig: {
      clmName: "type",
      keysObj: { key1: "type" },
      keyLevel: 1,
      type: "strings",
    },
    cellRenderer: infinityirrCellRenderer,
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    keyConfig: {
      clmName: "quantity",
      keysObj: { key1: "quantity" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: qtyCellRenderer,
  },
  {
    label: "Price",
    key: "rate",
    sortable: true,
    keyConfig: {
      clmName: "rate",
      keysObj: { key1: "rate" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: priceCellRenderer,
  },
  {
    label: "Transaction Value",
    key: "amount",
    sortable: true,
    keyConfig: {
      clmName: "amount",
      keysObj: { key1: "amount", key2: "actual_value" },
      keyLevel: 2,
      type: "numbers",
    },
    cellRenderer: tvaCellRenderer2,
  },
];

const EmptyState = (tab) => {
  const [isLoading, setIsLoading] = useState(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 100);

  return (
    <>
      {!isLoading ? (
        <div
          style={{
            marginTop: "11px",
            minHeight: !UserStore.isHybridNormalInstrument ? "342px" : "287px",
          }}
          className="tax_lots_empty flex is-justify-content-center is-align-items-center is-fullheight is-flex-direction-column"
        >
          <div className="empty_state_img_wrapper">
            <img width="100%" src={taxlotsEmpty} alt="transaction icon" />
          </div>
          <div className="empty_state_txt">
            {`You do not have any ${
              tab === "taxLots" ? "Taxation" : "Transactions"
            } to Report`}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

const TransactionModal = ({ open, transactions, taxData, loaderCondition }) => {
  const [selectedTab, setTab] = useState("transactions");
  const [sortingConfig, setSortingConfig] = useState({
    ...defaultTransactionSortConfig,
  });
  const [taxSortingConfig, setTaxSortingConfig] = useState({
    ...defaultTaxSortConfig,
  });
  const tablesRef = useRef(null);
  const taxTablesRef = useRef(null);
  const transactionRef = useRef(null);
  const taxRef = useRef(null);

  const { performanceRoute3 } = useParams();
  if (performanceRoute3 !== undefined && open) {
  } else if (open) {
  }

  // useEffect(() => {
  //   setInstrumentOrder({ key1: "transaction_date" }, false);
  //   setInstrumentTaxOrder({ key1: "days_held" }, false);
  //   // eslint-disable-next-line
  // }, [UserStore.isHydrated, transactions, taxData]);

  useEffect(() => {
    return () => {
      if (UserStore.portfolioPath.length === 2) {
        UserStore.setNormalHybirdFlow(false);
      }
      UserStore.upDateData("instrumentDetails", {
        ...UserStore.instrumentDetails,
        transaction: [],
      });
      UserStore.upDateData("instrumentDetails", {
        ...UserStore.instrumentDetails,
        taxLots: [],
      });
    };
  }, []);

  return (
    <Observer>
      {() => (
        <>
          <div className="snapshot_content">
            {PerformanceStore.modalLoader ? (
              <div className="ledger_popup_loader">
                <div style={{ height: "61px" }} className="modal_header">
                  <p className="modal_heading">{""}</p>
                </div>
                <img className="loader_gif" src={loaderGIF} alt="loading..." />
              </div>
            ) : (
              <div className="instru_det_outside" style={{ paddingTop: "0px" }}>
                <div className="modal_header portfolioModal">
                  <p className="modal_heading instru_det_title">
                    {UserStore.instrumentDetails?.details?.instrument_name}
                  </p>
                </div>

                <div
                  className={
                    UserStore.isHybridNormalInstrument
                      ? "snapshot_table_bg infinity_holdings_bg margin_for_instrument flex_class"
                      : "snapshot_table_bg margin_for_instrument flex_class"
                  }
                  style={
                    UserStore.isHybridNormalInstrument
                      ? { backgroundColor: "#1A1103" }
                      : {}
                  }
                >
                  <div className="tabsNTableWrapper">
                    <div className="tabs_wrapper">
                      <Tabs
                        onSelect={(value) => {
                          setTab(value);
                        }}
                        classN={"modal_Tab"}
                        tabs={
                          UserStore?.isInfinity === "1" ||
                          !UserStore?.instrumentDetails?.details?.isUnitBased
                            ? [
                                {
                                  label: "Transactions",
                                  value: "transactions",
                                },
                              ]
                            : [
                                {
                                  label: "Transactions",
                                  value: "transactions",
                                },
                                {
                                  label: "Taxation",
                                  value: "taxLots",
                                },
                              ]
                        }
                      />
                    </div>

                    {selectedTab === "transactions" && !!transactions && (
                      <div
                        ref={tablesRef}
                        tabIndex={0}
                        className={
                          UserStore.isHybridNormalInstrument
                            ? "infinity_table_wrapper modalWrapper"
                            : "normal_table_wrapper"
                        }
                        onScroll={(e) => {
                          transactionRef.current.handleScrollStart(e, "");
                        }}
                      >
                        {
                          false && ""
                          // <Table
                          //   data={instrumentData}
                          //   columns={infinityTransectionColumn}
                          //   tableClass="equity_summary_table_transac inModal"
                          //   EmptyState={() => EmptyState(selectedTab)}
                          //   handleSort={(key) => handleSort(key)}
                          //   sortKey={instrumentSortKey}
                          //   isAscending={isInstrumentAscending}
                          // />
                        }

                        <ScrollDataTable
                          ref={transactionRef}
                          tableData={transactions}
                          columns={infinityTransectionColumn}
                          tableClass="equity_summary_table_transac inModal"
                          EmptyState={() => EmptyState(selectedTab)}
                          sortingConfig={sortingConfig}
                          setSortingConfig={(data) => {
                            tablesRef.current.scrollTop = 0;
                            setSortingConfig(data);
                          }}
                        />
                      </div>
                    )}
                    {selectedTab === "taxLots" && !!taxData && (
                      <div
                        ref={taxTablesRef}
                        tabIndex={0}
                        className={
                          UserStore.isHybridNormalInstrument
                            ? "infinity_table_wrapper modalWrapper"
                            : "normal_table_wrapper"
                        }
                        onScroll={(e) => {
                          taxRef.current.handleScrollStart(e, "hi ref");
                        }}
                      >
                        {
                          false && ""
                          // <Table
                          //   data={instrumentTaxData}
                          //   columns={
                          //     UserStore.instrumentDetails.details.isUnitBased
                          //       ? taxLotsColumnUnitBased
                          //       : taxLotsColumnValueBased
                          //   }
                          //   tableClass={
                          //     instrumentTaxData.length
                          //       ? "equity_summary_table_tax modalTax"
                          //       : "equity_summary_table_tax modalTax noDataTable"
                          //   }
                          //   EmptyState={() => EmptyState(selectedTab)}
                          //   handleSort={(key) => handleSort(key)}
                          //   sortKey={instrumentTaxSortKey}
                          //   isAscending={isInstrumentTaxAscending}
                          // />
                        }

                        <ScrollDataTable
                          ref={taxRef}
                          tableData={taxData}
                          columns={
                            UserStore.instrumentDetails.details.isUnitBased
                              ? taxLotsColumnUnitBased
                              : taxLotsColumnValueBased
                          }
                          tableClass={
                            taxData.length
                              ? "equity_summary_table_tax modalTax"
                              : "equity_summary_table_tax modalTax noDataTable"
                          }
                          EmptyState={() => EmptyState(selectedTab)}
                          sortingConfig={taxSortingConfig}
                          setSortingConfig={(data) => {
                            taxTablesRef.current.scrollTop = 0;
                            setTaxSortingConfig(data);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </Observer>
  );
};

export default observer(TransactionModal);
